// Pagador Zemo V2 — status derivado no backend (`payer_v2` do GET /companies
// admin, C1012980). Textos EXATOS do owner.
export const PAYER_V2_BADGES = {
  cadastrado: { label: "Cadastrado", className: "bg-emerald-500/15 text-emerald-400" },
  pendente: { label: "Pendente", className: "bg-yellow-500/15 text-yellow-400" },
  dados_invalidos: { label: "Dados inválidos", className: "bg-red-500/15 text-red-400" },
};

export default function PayerV2Badge({ status, companyId }) {
  const badge = PAYER_V2_BADGES[status];
  if (!badge) return null;
  return (
    <span data-testid={`payer-v2-${companyId}`}
      className={`ml-2 px-2 py-0.5 rounded text-xs font-semibold ${badge.className}`}>
      {badge.label}
    </span>
  );
}
